import React, { type FC } from 'react';

import { Label } from '@gravity-ui/uikit';
import i18n from '@yandex-int/i18n';
import clx from 'classnames';
import * as keyset from 'i18n/PrivateApps';

interface Props {
    classNameExternal?: string;
}

const t = i18n(keyset);

const TvQuickAppIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2.67705 11.6403C2.21535 11.6403 1.85207 11.5096 1.58722 11.2484C1.32595 10.9835 1.19531 10.6202 1.19531 10.1585V3.96318C1.19531 3.50148 1.32595 3.13999 1.58722 2.87872C1.85207 2.61387 2.21535 2.48145 2.67705 2.48145H13.323C13.7847 2.48145 14.1462 2.61387 14.4074 2.87872C14.6723 3.13999 14.8047 3.50148 14.8047 3.96318V10.1585C14.8047 10.6202 14.6723 10.9835 14.4074 11.2484C14.1462 11.5096 13.7847 11.6403 13.323 11.6403H2.67705ZM2.74147 10.6095H13.2639C13.4286 10.6095 13.5556 10.5666 13.6451 10.4807C13.7346 10.3912 13.7793 10.2641 13.7793 10.0995V4.02223C13.7793 3.8576 13.7346 3.73233 13.6451 3.64643C13.5556 3.55696 13.4286 3.51222 13.2639 3.51222H2.74147C2.57683 3.51222 2.44978 3.55696 2.3603 3.64643C2.27082 3.73233 2.22608 3.8576 2.22608 4.02223V10.0995C2.22608 10.2641 2.27082 10.3912 2.3603 10.4807C2.44978 10.5666 2.57683 10.6095 2.74147 10.6095ZM5.25398 13.5193C5.12155 13.5193 5.00702 13.471 4.91039 13.3743C4.81375 13.2777 4.76543 13.1632 4.76543 13.0307C4.76543 12.8983 4.81375 12.7838 4.91039 12.6872C5.00702 12.5905 5.12155 12.5422 5.25398 12.5422H10.7461C10.8821 12.5422 10.9966 12.5905 11.0896 12.6872C11.1863 12.7838 11.2346 12.8983 11.2346 13.0307C11.2346 13.1632 11.1863 13.2777 11.0896 13.3743C10.9966 13.471 10.8821 13.5193 10.7461 13.5193H5.25398Z"
            fill="currentColor"
        />
    </svg>
);

const SmartScreenQuickAppIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.43486 10.0454C2.97316 10.0454 2.60988 9.91478 2.34503 9.65351C2.08376 9.38866 1.95312 9.02539 1.95312 8.56369V3.97783C1.95312 3.51613 2.08376 3.15464 2.34503 2.89337C2.60988 2.62852 2.97316 2.49609 3.43486 2.49609H12.5647C13.0264 2.49609 13.3879 2.62852 13.6492 2.89337C13.914 3.15464 14.0464 3.51613 14.0464 3.97783V8.56369C14.0464 9.02539 13.914 9.38866 13.6492 9.65351C13.3879 9.91478 13.0264 10.0454 12.5647 10.0454C8.40721 10.0454 7.59236 10.0454 3.43486 10.0454ZM3.49928 9.01465H12.5057C12.6703 9.01465 12.7974 8.9717 12.8868 8.8858C12.9763 8.79633 13.021 8.66927 13.021 8.50463V4.03688C13.021 3.87225 12.9763 3.74698 12.8868 3.66108C12.7974 3.5716 12.6703 3.52687 12.5057 3.52687H3.49928C3.33465 3.52687 3.20759 3.5716 3.11811 3.66108C3.02864 3.74698 2.9839 3.87225 2.9839 4.03688V8.50463C2.9839 8.66927 3.02864 8.79633 3.11811 8.8858C3.20759 8.9717 3.33465 9.01465 3.49928 9.01465ZM5.1051 13.5039C4.5 13.5039 4.1051 13 4.1051 12.5039C4.1051 11.1296 4.1051 10.6324 4.1051 10.5C6.5 10.5 10 10.5 11.8511 10.5C11.8511 10.6324 11.8511 12.1296 11.8511 12.5039C11.8511 13 11.5 13.5 11 13.5L5.1051 13.5039Z"
            fill="currentColor"
        />
    </svg>
);

export const QuickAppTvLabel: FC<Props> = ({ classNameExternal }) => (
    <Label className={clx(classNameExternal)} icon={<TvQuickAppIcon />} size="m">
        {t('yaos-tv')}
    </Label>
);

export const QuickAppSmartScreenLabel: FC<Props> = ({ classNameExternal }) => (
    <Label className={clx(classNameExternal)} icon={<SmartScreenQuickAppIcon />} size="m">
        {t('duo-max')}
    </Label>
);
